"use client";

import { HomeType } from "@/types";
import { HomeContentSections } from "./HomeContentSections";
import { useState } from "react";
import homeStyles from "@/styles/Home.module.scss";

export const MoreComponent = ({ homeContent }: { homeContent: HomeType | null }) => {
	const [visible, setVisible] = useState<boolean>(false);

	if (!homeContent) {
		return null;
	}

	return (
		<>
			{!visible && (
				<div className="flex flex-v-center section-wrapper">
					<button className="translate" onClick={() => setVisible(true)}>
						MEHR ÜBER DIE KAMPAGNE
					</button>
				</div>
			)}
			{visible && (
				<div className={homeStyles.extraPaddingTop}>
					<HomeContentSections sections={homeContent?.sections} homeContent={homeContent} renderQR={true} />
				</div>
			)}
		</>
	);
};
